import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export function BrandVoiceIconSG(props) {
    //  Extract props
    let { styles } = props;
    if (!styles) {
        // If styles is undefined, initilize it as an empty object
        styles = {};
    }
    return (_jsx(SvgIcon, Object.assign({ sx: Object.assign({ fontSize: '24px' }, styles), viewBox: '0 0 24 24' }, { children: _jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("mask", Object.assign({ id: "mask0_61073_81360", 
                    /* style="mask-type:alpha" */
                    maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24" }, { children: _jsx("rect", { width: "24", height: "24", fill: "#D9D9D9" }) })), _jsx("g", Object.assign({ mask: "url(#mask0_61073_81360)" }, { children: _jsx("path", { d: "M7 18V6H9V18H7ZM11 22V2H13V22H11ZM3 14V10H5V14H3ZM15 18V6H17V18H15ZM19 14V10H21V14H19Z", fill: "currentColor" }) }))] })) })));
}
